export const SpotsRemaining = ({ claimed = 61, total = 100 }) => {
  const pct = Math.min(100, (claimed / total) * 100);
  return (
    <div className="w-full max-w-xs" data-testid="spots-remaining-indicator">
      <div className="flex justify-between text-xs text-zinc-400 mb-1.5 font-mono">
        <span>{claimed}/{total} founding spots claimed</span>
        <span className="text-rose-400">{total - claimed} left</span>
      </div>
      <div className="h-2 w-full bg-white/10 rounded-full overflow-hidden">
        <div className="h-full bg-gradient-to-r from-rose-600 to-amber-500 rounded-full" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};
